module.exports = __webpack_public_path__ + "img/objects-align-top.80ec0eba.svg";